export function extractCSRFToken() {
  const element = document.getElementsByName('csrf-token').item(0);
  if (!(element instanceof HTMLMetaElement)) {
    throw new Error('Cannot retrieve CSRF token');
  }

  return element.content;
}
